// extracted by mini-css-extract-plugin
module.exports = {"root":"relatedProducts_root__dYhcO","galleryItemName":"relatedProducts_galleryItemName__Jieg9","galleryItemPrice":"relatedProducts_galleryItemPrice__5Vs6B"};